import React, { useState } from "react";
import Dialog from "components/Dialog";

type ClassroomTermSectionProps = {
  classroom: {
    term: { name: string; url: string } | null;
    policyCanDestroyManagementClassroomsSettingsClassroomTerms: boolean;
    managementClassroomSettingsClassroomTermPath: string;
  };
};

export default function ClassroomTermSection(
  { classroom }: ClassroomTermSectionProps,
) {
  const [isDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false);

  const handleDeleteDialogToggle = () => {
    setIsDeleteDialogVisible((prev) => !prev);
  };

  return (
    <div className="page__item">
      <h3 className="page__title --level-3">利用規約</h3>
      <div className="page__data-trailing">
        <div className="page__data-body --description">
          {classroom.term
            ? (
              <div className="term-preview">
                <a
                  href={classroom.term.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="term-filename"
                >
                  <span className="icon _icon" data-icon="document"></span>
                  {classroom.term.name}
                </a>
              </div>
            )
            : (
              "入会する受講者にむけて教室規約を追加しましょう"
            )}
        </div>

        {classroom.term &&
          classroom
            .policyCanDestroyManagementClassroomsSettingsClassroomTerms &&
          (
            <div className="_trailing">
              <div>
                <button
                  type="button"
                  className="button -appearance-transparent -color-neutral -shape-circle"
                  onClick={handleDeleteDialogToggle}
                >
                  <div className="_leading">
                    <span className="icon _icon" data-icon="garbage_can">
                    </span>
                  </div>
                </button>
              </div>
            </div>
          )}
      </div>
      {isDeleteDialogVisible && classroom.term && (
        <Dialog
          onCloseButtonClick={handleDeleteDialogToggle}
          title={`「${classroom.term.name}」を削除しますか？`}
        >
          <a
            href={classroom.managementClassroomSettingsClassroomTermPath}
            data-method="delete"
            className="button -appearance-transparent -size-m -color-negative"
          >
            <div className="_body">削除</div>
          </a>
        </Dialog>
      )}
    </div>
  );
}
